module.exports = __webpack_public_path__ + "a1792e4f52055f0e8224511f656db765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/i/i28.jpg
// module id = 632
// module chunks = 0